module.exports = __webpack_public_path__ + "images/emoji/closed_umbrella.fbbdd2fb51e2db0a3256.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/closed_umbrella.png
// module id = Cxdt
// module chunks = 13